<template>
  <v-container class="pieline-parent">
    <v-btn class="btn-historic" @click="showHistoric =  true">
      Histórico
    </v-btn>
    <pie
      @update-internal-step="updateInternal"
      :internalStep="internalStep"
      :initiate="initiate"
      :step="step"
      :data="dataPie" 
      :filters="filters"
      :isSearching="isSearchingEfectivity"
    />
    <transition name="fade-effect" mode="out-in">
      <skeleton-box key="skeleton-box" v-if="isSearchingPayment || internalStep < 5" flat>
        <v-container fluid>
          <v-layout column mt-4>
            <v-flex mt-4>
                <skeleton-line class="skeleton-payment"></skeleton-line>
            </v-flex>
          </v-layout>          
        </v-container>
      </skeleton-box>
      <stacked-area
        v-else 
        :data="dataLine"
        :internalStep="internalStep"
        key="stakedArea"
        :step.sync="step"
        :paymentDay="paymentDay"
        @update-step="$emit('update-step', 5)"
        @change-payment-day="paymentDay = $event" 
        class="mt-4"/>
    </transition>
    <v-layout row wrap>
      <v-flex xs12 pb-0 pt-2 class="text-xs-right">
        <span class="caption font-weight-thin">
          {{date}}
        </span>
      </v-flex>
    </v-layout>
    <historic v-if="showHistoric" 
      :show="showHistoric"
      :filters="filters"
      @close="showHistoric = false"/>
  </v-container>
</template>
<script>
import SkeletonAvatar from '@/components/global/skeletons/Avatar';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';
import SkeletonLine from '@/components/global/skeletons/Line';
import Pie from './Efectivity';
import StackedArea from './Payments';
import Historic from './Historic';

export default {
  props: {
    date: {
      type: String,
      default: 'Buscando...',
    },
    step: {
      type: Number,
      default: 0,
    },
    initiate: {
      type: Number,
      default: 0,
    },
    filters: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Pie,
    StackedArea,
    Historic,
    SkeletonBox,
    SkeletonLine,
    SkeletonAvatar,
  },
  data() {
    return {
      showHistoric: false,
      internalStep: 0,
      token1: this.axios.CancelToken.source(),
      token2: this.axios.CancelToken.source(),
      dataPie: [
        {
          title: 'Gestionados',
          total: 0,
          color: '#46ccd9',
          data: [
            {
              name: 'Gestionados',
              value: 0,
            },
            {
              name: 'No gestionados',
              value: 0,
            },
          ],
        },
        {
          title: 'Contactados',
          total: 0,
          color: '#47bfb8',
          data: [
            {
              name: 'Contactados',
              value: 0,
            },
            {
              name: 'No contactados',
              value: 0,
            },
          ],
        },
        {
          title: 'Contacto útil',
          total: 0,
          color: '#55c187',
          data: [
            {
              name: 'Contactados',
              value: 0,
            },
            {
              name: 'No contactados',
              value: 0,
            },
          ],
        },
        {
          title: 'Compromiso',
          total: 0,
          color: '#65e3a1',
          data: [
            {
              name: 'Compromiso de pago',
              value: 0,
            },
            {
              name: 'Sin compromiso',
              value: 0,
            },
          ],
        },
      ],
      isSearchingPayment: true,
      isSearchingEfectivity: true,
      paymentDay: 30,
      dataLine: [],
    };
  },
  methods: {
    updateInternal(num) {
      if (num > this.internalStep) {
        this.internalStep = num;
      }
    },
    cancelRequest(id) {
      this[`token${id}`].cancel('');
      this[`token${id}`] = this.axios.CancelToken.source();
    },
    search() {
      this.cancelRequest(1);
      this.isSearchingEfectivity = true;
      this.$emit('change-total', 0);
      this.axios.get('efectivity/report', {
        cancelToken: this.token1.token,
        params: {
          ...this.filters,
        },
      }).then((res) => {
        const temp = [
          'total',
          'contacted',
          'reached',
          'promise',
        ];
        const data = res.data.total || {};
        this.$emit('change-total', res.data.all);
        for (let i = 0; i < this.dataPie.length; i += 1) {
          let previous;
          if (i > 0) {
            previous = this.dataPie[i - 1].total;
          } else {
            previous = res.data.all;
          }
          this.dataPie[i].total = Number(data[temp[i]]) || 0;
          this.dataPie[i].data[0].value = this.dataPie[i].total;
          if (previous > 0) {
            this.dataPie[i].data[1].value = Math.abs(previous - this.dataPie[i].total) || 0;
          } else {
            this.dataPie[i].data[1].value = 0;
          }
        }
        this.isSearchingEfectivity = false;
        this.internalStep = 1;
      }).catch(() => {});
    },
    searchPayment() {
      this.cancelRequest(2);
      this.isSearchingPayment = true;
      this.axios.get('payments/report', {
        cancelToken: this.token2.token,
        params: {
          ...this.filters,
          paymentDay: this.paymentDay,
        },
      }).then((res) => {
        this.dataLine = [];
        const days = res.data;
        if (days.length > 0) {
          const date = days[0].date.toString().substr(0, 6);
          for (let i = 0; i < 31; i += 1) {
            let temp = i + 1;
            if (i < 9) {
              temp = `0${i + 1}`;
            }
            const day = days.find(x => x.date.toString().substr(-2) === String(temp)) || {};
            this.$set(this.dataLine, i, {
              date: `${date}${temp}`,
              totals: Number(day.total) || 0,
              reached: Number(day.reached) || 0,
              contacted: Number(day.contacted) || 0,
              promise: Number(day.promise) || 0,
            });
          }
        }
        this.isSearchingPayment = false;
      }).catch(() => {});
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        if (this.step >= 4) {
          this.$emit('update-step', 4);
          this.internalStep = 0;
          if (this.step >= this.initiate) {
            this.search();
            this.searchPayment();
          }
        }
      },
    },
    step(value) {
      if (value === this.initiate) {
        this.search();
        this.searchPayment();
      }
    },
    paymentDay() {
      this.searchPayment();
    },
  },
};
</script>
<style scoped>
.btn-historic {
  position: absolute;
  top: 10px;
  box-shadow: none;
  right: 20px;
  border: 1px solid #d7d7d7;
}
.skeleton-btn-historic {
  width: 8vw;
  height: 6vh;
  border-radius: 0!important;
}
.pieline-parent >>> .bordered {
  border: 1px solid #d7d7d7!important;
  min-height: 160px;
}
.skeleton-pie {
  width: 15vh;
  height: 15vh;
  margin-top: 6vh;
  margin-left: auto;
  margin-right: auto;
}
.skeleton-select-payment {
  width: 18vw;
  height: 6vh;
  border-radius: 0!important;
}
.skeleton-payment {
  height: 78vh;
  border-radius: 0!important;
}
</style>



// WEBPACK FOOTER //
// src/components/panelV2/Channels/PieLine/Index.vue